let styleStatus = {
	0:"bg-primary",
	1: "bg-primary",
	2: "bg-info",
	3: "bg-success",
	4: "bg-gray",
  }
export default styleStatus